module.exports = __webpack_public_path__ + "img/5.25993fba.jpg";